import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../../cloudinary-media/image'
import {
    RESIZE_FULL_MOBILE_ONE_THIRD_DESKTOP,
    RESIZE_HALF_MOBILE_ONE_FOURTH_DESKTOP
} from '../../../../../constants'

const CategorySmallImage = ({desktopImage, mobileImage, imageAlt, cardsLength}) => {
    const mobileSrc = mobileImage || desktopImage

    return (
        <>
            <Box
                display={{base: 'none', md: 'block'}}
                height="100%"
                className="category-small-image"
            >
                <CloudinaryImage
                    src={desktopImage}
                    alt={imageAlt}
                    aspectRatio="1:1"
                    imgSizes={{md: cardsLength < 4 ? '33vw' : '25vw', base: '50vw'}}
                    sizes={
                        cardsLength < 4
                            ? RESIZE_FULL_MOBILE_ONE_THIRD_DESKTOP
                            : RESIZE_HALF_MOBILE_ONE_FOURTH_DESKTOP
                    }
                    styles={{
                        aspectRatio: '1 / 1',
                        width: '100%',
                        height: 'auto',
                        htmlWidth: '100',
                        htmlHeight: '100'
                    }}
                />
            </Box>
            <Box display={{base: 'block', md: 'none'}} className="category-small-image">
                <CloudinaryImage
                    src={mobileSrc}
                    alt={imageAlt}
                    aspectRatio="1:1"
                    imgSizes={{md: cardsLength < 4 ? '33vw' : '25vw', base: '50vw'}}
                    sizes={
                        cardsLength < 4
                            ? RESIZE_FULL_MOBILE_ONE_THIRD_DESKTOP
                            : RESIZE_HALF_MOBILE_ONE_FOURTH_DESKTOP
                    }
                    styles={{
                        aspectRatio: '1 / 1',
                        width: '100%',
                        height: 'auto',
                        htmlWidth: '100',
                        htmlHeight: '100'
                    }}
                />
            </Box>
        </>
    )
}

CategorySmallImage.propTypes = {
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    cardsLength: PropTypes.number,
    imageAlt: PropTypes.string
}

export default CategorySmallImage
